import { useEffect } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import { useSidebar } from '../hooks/index.jsx'
import Sidebar from './Sidebar.jsx'
import Header from './Header.jsx'
import api from '../lib/api'
import { setAudioEnabled, playChime } from '../lib/notificationSound'
import { OnboardingProvider } from '../context/OnboardingContext.jsx'
import OnboardingRail from './onboarding/OnboardingRail.jsx'
import OnboardingPill from './onboarding/OnboardingPill.jsx'
import WelcomeModal from './onboarding/WelcomeModal.jsx'
import AICreditsModal from './AICreditsModal.jsx'
import './Layout.css'

function useNotificationAudioBridge() {
  useEffect(() => {
    let cancelled = false
    const syncEnabled = async () => {
      try {
        const res = await api.get('/api/v1/settings/notifications')
        const s = res.data?.settings || {}
        if (!cancelled) setAudioEnabled(!!s.audio_enabled)
      } catch (e) { /* ignore */ }
    }
    syncEnabled()
    const onFocus = () => syncEnabled()
    window.addEventListener('focus', onFocus)

    const onSwMessage = (event) => {
      const msg = event.data
      if (msg && msg.type === 'push') playChime()
    }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', onSwMessage)
    }

    return () => {
      cancelled = true
      window.removeEventListener('focus', onFocus)
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', onSwMessage)
      }
    }
  }, [])
}

function Layout() {
  const { isAuthenticated, isLoading } = useAuth()
  const { isOpen, toggle, close } = useSidebar()
  useNotificationAudioBridge()

  if (isLoading) return <div className="layout-loading"><div className="loader"></div></div>
  if (!isAuthenticated) return <Navigate to="/login" replace />

  return (
    <OnboardingProvider>
      <div className="layout">
        <Sidebar isOpen={isOpen} onClose={close} />
        <div className={`layout-main ${isOpen ? 'sidebar-open' : ''}`}>
          <Header onMenuClick={toggle} isSidebarOpen={isOpen} />
          <main className="layout-content"><Outlet /></main>
        </div>
        <WelcomeModal />
        <OnboardingRail />
        <OnboardingPill />
        <AICreditsModal />
      </div>
    </OnboardingProvider>
  )
}

export default Layout
